/**
 * @packageDocumentation
 * @module      P_Drive_SensorStatusDriveAnyModule.ts
 * @description Contains Emc related data
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
export default class P_Drive_SensorStatusDriveAnyModule {
    constructor() {
        this.MnCassetteClosed = 0;
        this.MnCassetteDetected = 0;
        this.MnTrackFwdPresence = 0;
        this.MnEstopPressed = 0;
        this.Arm_Lock_Button = 0;
        this.Arm_Lock_Frame = 0;
    }
    static fromJSON(json) {
        let p_Drive_SensorStatusDriveAnyModule = new P_Drive_SensorStatusDriveAnyModule();
        //Below fields arent required any longer
        /*p_Drive_SensorStatusDriveAnyModule.MnCassetteClosed = json["VMOT Sense"];
        p_Drive_SensorStatusDriveAnyModule.MnCassetteDetected = json["VMOT Sense"];
        p_Drive_SensorStatusDriveAnyModule.MnTrackFwdPresence = json["VMOT Sense"];
        p_Drive_SensorStatusDriveAnyModule.MnEstopPressed = json["VMOT Sense"];
        p_Drive_SensorStatusDriveAnyModule.Arm_Lock_Button = json["VMOT Sense"];
        p_Drive_SensorStatusDriveAnyModule.Arm_Lock_Frame = json["VMOT Sense"];*/
        return p_Drive_SensorStatusDriveAnyModule;
    }
}
//# sourceMappingURL=P_Drive_SensorStatusDriveAnyModule.js.map